import React, { useCallback, useContext, useEffect, useState } from "react";
import "./SmoothSlider.css";
import { PCarousel } from "@porsche-design-system/components-react";
import { IsRotatedContext } from "MainApp/assets/utils/context/isRotatedContext";
import useIsPhone from "MainApp/assets/utils/hooks/useIsPhone";
import { SkeletonImagePreload } from "MainApp/assets/visual/styles/globalStyles/globalJsxStyles";

const SmoothSlider = ({ images, imageLoaded, setImageLoaded }) => {
  const [formattedUrls, setFormattedUrls] = useState([]);
  const [displayUrls, setDisplayUrls] = useState([]);
  const [imageLoading, setImageLoading] = useState([]);
  const isPhone = useIsPhone();

  // Formatear las URLs usando el baseUrl cuando sea necesario
  useEffect(() => {
    if (images && images.length > 0) {
      const baseUrl = process.env.REACT_APP_API_BASE_URL;
      const newUrls = images.map((url) => {
        if (url.startsWith("http://") || url.startsWith("https://")) {
          return url;
        }
        return `${baseUrl}${url}`;
      });
      setFormattedUrls(newUrls);
    }
  }, [images]);

  // En móviles, utilizamos las URLs directamente
  useEffect(() => {
    if (formattedUrls.length > 0) {
      if (isPhone) {
        setDisplayUrls(formattedUrls);
        setImageLoading(new Array(formattedUrls.length).fill(true));
      } else {
        // Para escritorio puedes seguir usando la lógica de caché si lo necesitas.
        // Aquí simplemente usamos las URLs directas para simplificar.
        setDisplayUrls(formattedUrls);
        setImageLoading(new Array(formattedUrls.length).fill(true));
      }
    }
  }, [formattedUrls, isPhone]);

  const handleImageLoaded = useCallback(() => {
    if (!imageLoaded) {
      setTimeout(() => setImageLoaded(true), 0);
    }
  }, [imageLoaded, setImageLoaded]);

  const handleImageLoad = (index) => {
    setImageLoading((prevLoading) => {
      const newLoading = [...prevLoading];
      newLoading[index] = false;
      handleImageLoaded();
      return newLoading;
    });
  };

  const { isRotated } = useContext(IsRotatedContext);
  const rotatedStyle = {
    height: isPhone ? (isRotated ? "32.5svw" : "32.5svh") : "32.5svh",
  };

  return (
    <PCarousel pagination={true} slidesPerPage="auto" width="extended">
      {displayUrls.map((url, index) => (
        <div className="newCard" key={index}>
          {url ? (
            <img
              className="newCardImage"
              style={rotatedStyle}
              src={url}
              alt={`image-${index}`}
              onLoad={() => handleImageLoad(index)}
              onError={() => handleImageLoad(index)}
              // Puedes agregar crossOrigin si lo requieres:
              // crossOrigin="anonymous"
            />
          ) : (
            <div className="imageError">Imagen no disponible</div>
          )}
        </div>
      ))}

      {displayUrls.length > 0 && (
        <div className="extraDiv">{/* Contenido adicional */}</div>
      )}
    </PCarousel>
  );
};

export default SmoothSlider;
